module.exports = __webpack_public_path__ + "static/img/case.0028f357.jpg";